import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import * as saveAs from 'file-saver';
import { ProcessEventLogManagementControllerService } from '@iota/inh-core-v1-management-client';
import { ToastService } from 'src/app/shared/services/toast.service';
import {
    DownloadProcessingReport,
    DownloadProcessingReportFailure,
    DownloadProcessingReportSuccess,
    LoadProcessEventLogs,
    LoadProcessEventLogsFailure,
    LoadProcessEventLogsSuccess
} from '../actions/process-event-log.actions';

@Injectable()
export class ProcessEventLogEffects {
    loadProcessEventLogs$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadProcessEventLogs),
            mergeMap(({ eventTypes, from, to, page, pageSize, sortingField, sortingAscending }) =>
                this.api.findAll(eventTypes, from || undefined, to || undefined, page, pageSize, sortingField, sortingAscending).pipe(
                    map((result) => LoadProcessEventLogsSuccess({ page: result })),
                    catchError((error) => of(LoadProcessEventLogsFailure({ error })))
                )
            )
        )
    );

    downloadReport$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DownloadProcessingReport),
            mergeMap(({ eventLogId }) =>
                this.api.downloadReport(eventLogId).pipe(
                    tap((blob) => saveAs(blob, 'processing-report.xlsx')),
                    map(() => DownloadProcessingReportSuccess()),
                    catchError(() => {
                        this.toastService.showError($localize`Failed to download processing report.`);
                        return of(DownloadProcessingReportFailure({ error: 'Download failed' }));
                    })
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private api: ProcessEventLogManagementControllerService,
        private toastService: ToastService
    ) {}
}
